import React from 'react';
import PropTypes from 'prop-types';
import Form from './Form';

const Edit = ({
  isModalOpen,
  onCloseHandler,
  onSubmitHandler,
  error,
  submitting,
  staleVersionError,
  onRefreshHandler,
  masterProducts,
  defaultCoverageOptOut,
}) => (
  <Form
    isModalOpen={isModalOpen}
    onCloseHandler={onCloseHandler}
    onSubmitHandler={onSubmitHandler}
    error={error}
    submitting={submitting}
    staleVersionError={staleVersionError}
    onRefreshHandler={onRefreshHandler}
    masterProducts={masterProducts}
    defaultCoverageOptOut={defaultCoverageOptOut}
    action='edit'
  />
);

Edit.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  staleVersionError: PropTypes.string,
  onRefreshHandler: PropTypes.func,
  // Needed to tell an existing seller-side row's Seller radio apart from
  // Seller-paid — sellerNumber alone cannot say which, since both master
  // types veto through that same column.
  masterProducts: PropTypes.array,
  defaultCoverageOptOut: PropTypes.shape({
    id: PropTypes.string,
    version: PropTypes.number,
    buyerNumber: PropTypes.string,
    sellerNumber: PropTypes.string,
    auctionAccessNumber: PropTypes.string,
    productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    productCode: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    notes: PropTypes.string,
    createdBy: PropTypes.string,
    updatedBy: PropTypes.string,
    updatedAt: PropTypes.string,
  }),
};

Edit.defaultProps = {
  isModalOpen: false,
  error: null,
  submitting: false,
  staleVersionError: null,
  onRefreshHandler: null,
  masterProducts: [],
  defaultCoverageOptOut: null,
};

export default Edit;
